import { CloseOutlined } from "@ant-design/icons";
import { Row } from "antd";
import React from "react";

export default function Close({ onClose }) {
  return (
    <Row justify="end">
      <CloseOutlined
        style={{
          margin: "5px",
          cursor: "pointer",
          fontSize: "24px",
          color: "var(--adm-color-danger)",
        }}
        onClick={onClose}
      />
    </Row>
  );
}
